export enum BlockButtonTypeEnum {
  NORMAL = 'normal',
  SYSTEM = 'system',
  CHIBI_JOB = 'chibi-job',
  OTHER_SITES = 'other-sites'
}
